import React, { useEffect, useState } from "react";
import ItemCard from "../components/ItemCard";
import { Link } from "react-router-dom";
import getItems from "../api/getItems";

function Items() {
  const [items, setItems] = useState([]);
  const [imageVersion, setImageVersion] = useState(Date.now());

  useEffect(() => {
    const GetItem = async () => {
      let data = await getItems();
      if (data) {
        setItems(data);
      }
    };
    GetItem();
  }, []);
  return (
    <>
      <section className="body-font text-gray-600">
        <div className="container mx-auto py-12">
          <div className="flex flex-row-reverse mb-8 py-4 border-b">
            <Link
              className="text-lg text-blue-500 font-bold underline"
              to={`${process.env.PUBLIC_URL}/add-item`}
            >
              إضافة منتج جديد
            </Link>
          </div>
          <div className="-m-4 flex flex-wrap flex-row-reverse" id="main-items-list">
            {items.map((item) => {
              return (
                <ItemCard
                  item={item}
                  onImageUpdated={() => setImageVersion(Date.now())}
                  key={item.id}
                />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default Items;
